// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LegendeCreneauDelete_buttons__37OHp {\n  margin-top: 1rem;\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Legende/LegendeCreneauDelete.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".buttons {\n  margin-top: 1rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttons": "LegendeCreneauDelete_buttons__37OHp"
};
export default ___CSS_LOADER_EXPORT___;
